
import { PropType, defineComponent } from 'vue';
import { AvailableLoan } from '@/interfaces/loan';
import MomntIcon from '~/components/Icons/MomntIcon.vue';
import formatApplicationId from '@/filters/application-id';

export default defineComponent({
  name: 'LoanItem',

  components: { MomntIcon },

  props: {
    loan: { type: Object as PropType<AvailableLoan>, required: true },
  },

  computed: {
    isInCollection(): boolean {
      return this.loan.collection?.in_collection;
    },

    iconName(): string {
      return `program_${this.loan.program.toLowerCase().replaceAll(' ', '_')}`;
    }
  },

  methods: {
    onSelect() {
      this.$emit('select', this.loan);
    },

    formatApplicationId
  }
});
